import styled from 'styled-components';

import {flexCenterVertically} from '~/shared/theme/FlexLayout';

import CellRenderer from './CellRenderer';

const CustomTableRowStyled = styled.tr.attrs(({openRows, rowId}) => ({
  ...(rowId && openRows?.includes(rowId) && {'aria-expanded': 'true'}),
}))`
  height: 40px;
  ${flexCenterVertically};
  color: ${({theme}) => theme.userReport.general.primaryText};
  ${({onClick}) =>
    onClick &&
    `
    &.parentRow {
      cursor: pointer;
    }
  `}
  ${({isTotalAmountRow, theme, customTableFooterColor, withRoundedCorners}) =>
    isTotalAmountRow &&
    `
    background: ${customTableFooterColor || theme.userReport.totalsTable.markedRowBackground};
    font-weight: bold;
    color: ${theme.userReport.totalsTable.text};
    ${withRoundedCorners && `
      display: block;
      border-radius: 8px;
      overflow: hidden;
    `}
  `}

  &.parentRow {
    border-bottom: 1px solid ${({theme}) => theme.colors.gray500};
  }

  &.totalsRow {
    background-color: ${({theme}) => theme.userReport.general.markedRowBackground};
  }

  &.parentRow:not(.collapsed):not(.firstChildRow):not(.lastChildRow):not(.totalsRow) {
    &:hover {
      box-shadow: ${({theme}) => theme.shadows.shadow1};
    }
  }

  &.firstChildRow {
    border-bottom: 0;
  }

  &.lastChildRow {
    border-bottom: 1px solid ${({theme}) => theme.colors.gray500};
  }

  &.noBottomBorder {
    border-bottom: 0;
  }
`;

const CustomTableRow = ({getCssClasses, index, openRows, onMenuClick, openedRowMenuId, withRoundedCorners, customTableFooterColor, ...props}) => {
  const {rowData, columns, toggleRow, rowDataTestId, customArtributeOptions} = props;
  const additionalArtributes = {};
  const classes = getCssClasses ? getCssClasses({index}) : '';
  const handleToggleRow = () => {
    if (!toggleRow) {
      return;
    }
    toggleRow(rowData?.id);
  };

  if (customArtributeOptions) {
    const {getArtributeData, dataArg, artributeName} = customArtributeOptions;
    additionalArtributes[artributeName] = getArtributeData(rowData[dataArg]);
  }

  return (
    <CustomTableRowStyled
      isTotalAmountRow={rowData?.isTotalAmountRow}
      className={classes}
      openRows={openRows}
      rowId={rowData?.id}
      onClick={handleToggleRow}
      data-test-id={rowDataTestId ? rowDataTestId + rowData?.id : ''}
      withRoundedCorners={withRoundedCorners}
      customTableFooterColor={customTableFooterColor}
      {...additionalArtributes}
    >
      {columns?.map(({name, width}) => {
        const cellData = rowData[name];
        return (
          <CellRenderer
            key={name}
            headerName={name}
            onMenuClick={onMenuClick}
            openedRowMenuId={openedRowMenuId}
            useTranslate={rowData?.isTotalAmountRow}
            boldAllPrices
            cellData={cellData}
            dataKey={name}
            cellWidth={width}
            openRows={openRows}
            {...props}
          />
        );
      })}
    </CustomTableRowStyled>
  );
};

export default CustomTableRow;
